var map = {
	"./DK/en.js": 680,
	"./DR/en.js": 681,
	"./OST2/en.js": 682,
	"./PstViewer/en.js": 683,
	"./SPB/en.js": 684,
	"./Sync2/en.js": 685,
	"./Sync2Cloud/en.js": 686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;